import { useGlobalSearchParams } from 'expo-router'

export const useSearchProductOpened = (): boolean => {
    const { searchOpen } = useGlobalSearchParams<{ searchOpen?: 'true' }>()

    return searchOpen === 'true'
}
